import React, { FC, ReactNode } from 'react';
import styles from './FormContainer.module.scss';
const FormContainer: FC<{ children: ReactNode }> = ({ children }) => {
	return <div className={styles.FormContainer}>{children}</div>;
};

export default FormContainer;
